import React from "react";
import { trackOutboundClick } from "../analytics";
import "./Footer.css";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-address">
          <p className="footer-address-text">
            3424 Peachtree Road NE, Suite 2200 - Atlanta, GA 30326 -
            <a
              href="mailto:info@pagarva.com"
              className="footer-email"
              onClick={() => trackOutboundClick("mailto:info@pagarva.com", "Email")}
            >
              {" "}
              info@pagarva.com
            </a>
          </p>
        </div>
        <div className="footer-separator"></div>
        <div className="footer-content">
          <p className="footer-copyright">
            © 2025 Pagarva LLC. All rights reserved.
          </p>
          <div className="footer-links">
            <a
              href="https://app.enzuzo.com/policies/tos/e6fdec98-409a-11f0-8e8f-2b25e9ab4b31"
              target="_blank"
              rel="noreferrer"
              className="footer-link"
              onClick={() => trackOutboundClick("https://app.enzuzo.com/policies/tos/e6fdec98-409a-11f0-8e8f-2b25e9ab4b31", "Terms of Use")}
            >
              Terms of Use
            </a>
            <a
              href="https://app.enzuzo.com/policies/privacy/e6fdec98-409a-11f0-8e8f-2b25e9ab4b31"
              target="_blank"
              rel="noreferrer"
              className="footer-link"
              onClick={() => trackOutboundClick("https://app.enzuzo.com/policies/privacy/e6fdec98-409a-11f0-8e8f-2b25e9ab4b31", "Privacy Policy")}
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
